export default __webpack_public_path__ + "static/media/10d.80fd03b5.png";